// caiet UC31-03: copying client_id and client_secret from the browser. The
// answer is whether the value reached the clipboard, never an exception, so no
// caller can report a refused write as a copy: an insecure origin has no
// `navigator.clipboard`, and a denied permission rejects the write.
// per docs/shape-ops-credential-copy-and-secret-date.md §2.1
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
